'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (config, layout, isStacked) {
    var direction = sortOrderMap.get(parseInt(layout.sortOrder));

    return getSortedConfig(config, isStacked, direction);
};

var _arrayPluck = require('d2-utilizr/lib/arrayPluck');

var _arrayPluck2 = _interopRequireDefault(_arrayPluck);

var _arraySort = require('d2-utilizr/lib/arraySort');

var _arraySort2 = _interopRequireDefault(_arraySort);

var _getStackedData = require('./getStackedData');

var _getStackedData2 = _interopRequireDefault(_getStackedData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortOrderMap = new Map([[-1, 'ASC'], [1, 'DESC']]);

function getIndexOrder(config, isStacked, direction) {
    var dataToBeSorted = isStacked ? (0, _getStackedData2.default)(config.series) : config.series[0].data.slice();

    var dataObjectsToBeSorted = dataToBeSorted.map(function (value, index) {
        return { index: index, value: value };
    });

    (0, _arraySort2.default)(dataObjectsToBeSorted, direction, 'value');

    return (0, _arrayPluck2.default)(dataObjectsToBeSorted, 'index');
}

function getSortedConfig(config, isStacked, direction) {
    var categories = config.xAxis.categories;
    var series = config.series;
    var indexOrder = getIndexOrder(config, isStacked, direction);
    var sortedConfig = _extends({}, config);

    sortedConfig.xAxis.categories = indexOrder.map(function (index) {
        return categories[index];
    });
    sortedConfig.series = series.map(function (seriesObj) {
        return _extends({}, seriesObj, {
            data: seriesObj.data.map(function (value, index) {
                return seriesObj.data[indexOrder[index]];
            })
        });
    });

    return sortedConfig;
}
//# sourceMappingURL=getSortedConfig.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-charts-api/lib/config/adapters/dhis_highcharts/getSortedConfig.js
 ** module id = 239
 ** module chunks = 0 1
 **/